import { Link } from 'react-router-dom';

interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function Button({ 
  children, 
  href, 
  onClick, 
  variant = 'primary', 
  size = 'md',
  className = ''
}: ButtonProps) {
  const baseStyles = 'inline-block font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer';
  
  const variants = {
    primary: 'bg-yellow-400 text-black hover:bg-yellow-500',
    secondary: 'bg-transparent border-2 border-white text-white hover:bg-white hover:text-black'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
    }
    // Scroll to top when navigating to contact page
    if (href === '/contact') {
      window.scrollTo(0, 0);
    }
  };

  if (href) {
    if (href.startsWith('#')) {
      return (
        <a href={href} className={classes} onClick={handleClick}>
          {children}
        </a>
      );
    }
    return (
      <Link to={href} className={classes} onClick={handleClick}>
        {children}
      </Link>
    );
  }

  return (
    <button onClick={handleClick} className={classes}>
      {children}
    </button>
  );
}
